import React from 'react';
import './WhyChooseUs.css';
import { FaClock, FaShieldAlt, FaUserTie, FaCar } from 'react-icons/fa';

function WhyChooseUs() {
  const features = [
    {
      icon: <FaClock />,
      title: "24/7 Disponible",
      description: "Service disponible jour et nuit, 7 jours sur 7"
    },
    {
      icon: <FaShieldAlt />,
      title: "Sécurité Garantie",
      description: "Chauffeurs professionnels et véhicules assurés"
    },
    {
      icon: <FaUserTie />,
      title: "Service Premium",
      description: "Une expérience de transport haut de gamme"
    },
    {
      icon: <FaCar />,
      title: "Flotte Moderne",
      description: "Véhicules récents et bien entretenus"
    }
  ];

  return (
    <section className="why-choose-us">
      <div className="container">
        <div className="why-choose-us-header">
          <h2 className="why-choose-us-title">Pourquoi Nous Choisir</h2>
          <p className="why-choose-us-subtitle">
            Une équipe dévouée et professionnelle pour assurer votre confort et votre sécurité
          </p>
        </div>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs; 